import { render, staticRenderFns } from "./entertainmentIndex.vue?vue&type=template&id=907c8468&scoped=true"
import script from "./entertainmentIndex.vue?vue&type=script&lang=js"
export * from "./entertainmentIndex.vue?vue&type=script&lang=js"
import style0 from "./entertainmentIndex.vue?vue&type=style&index=0&id=907c8468&prod&lang=css"
import style1 from "./entertainmentIndex.vue?vue&type=style&index=1&id=907c8468&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907c8468",
  null
  
)

export default component.exports